import React from 'react';
import { MenuInput } from './SizeAndPositionButtons';
import { updateBubbleControlPoint, updateCurrentSlideThumbnail, updateShapePosition } from '../../actions/CurrentSlideActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import shapeConstants from '../../constants/ShapeConstants';
import {connect} from "react-redux";

const PositionViewContent = React.createClass({
    getInitialState() {
        const shapeModel = this.getContextTarget();

        if (shapeModel.type == shapeConstants.COMPLEX_SPEAK_BUBBLE) {
            return {
                x: shapeModel.x,
                y: shapeModel.y,
                type: shapeModel.type,
                cx: shapeModel.cx,
                cy: shapeModel.cy,
                cx1: shapeModel.cx1,
                cy1: shapeModel.cy1,
                cx2: shapeModel.cx2,
                cy2: shapeModel.cy2,
                cx3: shapeModel.cx3,
                cy3: shapeModel.cy3,
                cx4: shapeModel.cx4,
                cy4: shapeModel.cy4,
                cx5: shapeModel.cx5,
                cy5: shapeModel.cy5
            };
        } else {
            return {
                x: shapeModel.x,
                y: shapeModel.y,
                type: shapeModel.type,
                cx: shapeModel.cx,
                cy: shapeModel.cy
            };
        }
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
            var contextTarget = this.getContextTarget();
            
            if (this.state.type === shapeConstants.SPEAK_BUBBLE || this.state.type === shapeConstants.COMPLEX_SPEAK_BUBBLE || this.state.type === shapeConstants.THOUGHT_BUBBLE || this.state.type === shapeConstants.SCREAM_BUBBLE)
                if (this.state.type === shapeConstants.COMPLEX_SPEAK_BUBBLE)
                    this.setState({x: contextTarget.x, y: contextTarget.y, cx: contextTarget.cx, cy: contextTarget.cy, cx1: contextTarget.cx1, cy1: contextTarget.cy1, cx2: contextTarget.cx2, cy2: contextTarget.cy2, cx3: contextTarget.cx3, cy3: contextTarget.cy3, cx4: contextTarget.cx4, cy4: contextTarget.cy4, cx5: contextTarget.cx5, cy5: contextTarget.cy5});
                else
                    this.setState({x: contextTarget.x, y: contextTarget.y, cx: contextTarget.cx, cy: contextTarget.cy});
            else
                this.setState({x: contextTarget.x, y: contextTarget.y});
        }
    },
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.shapeModel.uuid)
                return shapes[i];
        }

        return this.props.shapeModel;
    },
    changePosition(x, y) {
        const newX = parseInt(x) || 0;
        const newY = parseInt(y) || 0;

        const shapeModel = this.props.shapeModel;
        this.setState({x: newX, y: newY});

        this.props.dispatch(updateShapePosition(shapeModel.uuid, newX, newY));
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    changeBubbleControlPoint(cx, cy, property) {
        const newX = parseInt(cx) || 0;
        const newY = parseInt(cy) || 0;

        const shapeModel = this.props.shapeModel;

        switch(property) {
            case 'controlPoint' : {
                this.setState({cx: newX, cy: newY});
                break;
            }
            case 'controlPoint1' : {
                this.setState({cx1: newX, cy1: newY});
                break;
            }
            case 'controlPoint2' : {
                this.setState({cx2: newX, cy2: newY});
                break;
            }
            case 'controlPoint3' : {
                this.setState({cx3: newX, cy3: newY});
                break;
            }
            case 'controlPoint4' : {
                this.setState({cx4: newX, cy4: newY});
                break;
            }
            case 'controlPoint5' : {
                this.setState({cx5: newX, cy5: newY});
                break;
            }
        }

        this.props.dispatch(updateBubbleControlPoint(shapeModel.uuid, newX, newY, property));

        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        this.props.dispatch(updateCurrentSlideThumbnail(true));
    },
    render() {
        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        var idValue1;
        var idValue2;

        if (this.state.type === shapeConstants.SPEAK_BUBBLE ||
            this.state.type === shapeConstants.THOUGHT_BUBBLE ||
            this.state.type === shapeConstants.SCREAM_BUBBLE) {
            idValue2 = "resizeLastItem";
        } else
            if (this.state.type != shapeConstants.COMPLEX_SPEAK_BUBBLE)
                idValue1 = "resizeLastItem";

        return (
            <div>
                <h3 style={smallTextStyle}>{locales.getCaption('Position', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.x} yValue={this.state.y} onChangeHandler={this.changePosition}/>
                    <MenuInput id={idValue1} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.y} xValue={this.state.x} onChangeHandler={this.changePosition}/>
                </div>

                {
                    this.state.type === shapeConstants.SPEAK_BUBBLE ||
                    this.state.type === shapeConstants.COMPLEX_SPEAK_BUBBLE ||
                    this.state.type === shapeConstants.THOUGHT_BUBBLE ||
                    this.state.type === shapeConstants.SCREAM_BUBBLE ?
                        <div>
                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu')}</h3>

                            <div style={buttonWrapperStyle}>
                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx} yValue={this.state.cy} property='controlPoint' onChangeHandler={this.changeBubbleControlPoint}/>
                                <MenuInput id={idValue2} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy} xValue={this.state.cx} property='controlPoint' onChangeHandler={this.changeBubbleControlPoint}/>
                            </div>

                            {this.state.type === shapeConstants.COMPLEX_SPEAK_BUBBLE ?
                                <div>
                                    {this.props.shapeModel.cx1 ?
                                        <div>
                                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu') + ' 2'}</h3>

                                            <div style={buttonWrapperStyle}>
                                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx1} yValue={this.state.cy1} property='controlPoint1' onChangeHandler={this.changeBubbleControlPoint}/>
                                                <MenuInput id={!this.props.shapeModel.cx2 ? 'resizeLastItem' : undefined} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy1} xValue={this.state.cx1} property='controlPoint1' onChangeHandler={this.changeBubbleControlPoint}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {this.props.shapeModel.cx2 ?
                                        <div>
                                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu') + ' 3'}</h3>

                                            <div style={buttonWrapperStyle}>
                                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx2} yValue={this.state.cy2} property='controlPoint2' onChangeHandler={this.changeBubbleControlPoint}/>
                                                <MenuInput id={!this.props.shapeModel.cx3 ? 'resizeLastItem' : undefined} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy2} xValue={this.state.cx2} property='controlPoint2' onChangeHandler={this.changeBubbleControlPoint}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {this.props.shapeModel.cx3 ?
                                        <div>
                                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu') + ' 4'}</h3>

                                            <div style={buttonWrapperStyle}>
                                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx3} yValue={this.state.cy3} property='controlPoint3' onChangeHandler={this.changeBubbleControlPoint}/>
                                                <MenuInput id={!this.props.shapeModel.cx4 ? 'resizeLastItem' : undefined} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy3} xValue={this.state.cx3} property='controlPoint3' onChangeHandler={this.changeBubbleControlPoint}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {this.props.shapeModel.cx4 ?
                                        <div>
                                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu') + ' 5'}</h3>

                                            <div style={buttonWrapperStyle}>
                                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx4} yValue={this.state.cy4} property='controlPoint4' onChangeHandler={this.changeBubbleControlPoint}/>
                                                <MenuInput id={!this.props.shapeModel.cx5 ? 'resizeLastItem' : undefined} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy4} xValue={this.state.cx4} property='controlPoint4' onChangeHandler={this.changeBubbleControlPoint}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                    {this.props.shapeModel.cx5 ?
                                        <div>
                                            <h3 style={smallTextStyle}>{locales.getCaption('ControlPoint', 'sizePosMenu') + ' 6'}</h3>

                                            <div style={buttonWrapperStyle}>
                                                <MenuInput isInt={true} labelText={locales.getCaption('Xposition', 'sizePosMenu')} value={this.state.cx5} yValue={this.state.cy5} property='controlPoint5' onChangeHandler={this.changeBubbleControlPoint}/>
                                                <MenuInput id={'resizeLastItem'} isInt={true} labelText={locales.getCaption('Yposition', 'sizePosMenu')} value={this.state.cy5} xValue={this.state.cx5} property='controlPoint5' onChangeHandler={this.changeBubbleControlPoint}/>
                                            </div>
                                        </div>
                                        : null
                                    }
                                </div>
                                : null
                            }
                        </div>
                        : null
                }
            </div>
        )
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var refreshShapePosition = state.menu.refreshShapePosition;

    return {
        refreshShapePosition
    };
}

export const PositionView = connect(mapStateToProps)(PositionViewContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/PositionView.js
 **/